<div>
	<translation-search-filter-bar #translationSearchFilterBar></translation-search-filter-bar>
</div>

<div class="wrapper">
	<div
		*ngFor="
			let translationKey of translationManagerService.clientTranslationKeys
				| translationTextSearch
					: translationSearchFilterBar.currentSearchText
					: translationSearchFilterBar.currentSearchType
		"
	>
		<button
			(click)="emitLoadClientLanguageInfo(translationKey)"
			class="client-language-info-btn"
			[class.selected]="translationKey.key == selectedTranslationKey.key"
		>
			<span>{{ translationKey.key }}</span>
		</button>
	</div>
</div>
